import {
  UPDATE_CAMSET,
  TOGGLE_SINGLE_VIEW,
  TOGGLE_FULLSCREEN_VIEW,
  SET_LAYOUT,
  LOGOUT_USER,
  CHANGE_USER_VIEW,
  SET_VIEW,
  UPDATE_CAMERAS_IN_VIEW,
  SHOW_UNSAVED_VIEW_MODAL,
  SAVE_VIEW,
} from '../actions/types';

const INITIAL_STATE = {
  selectedSingleViewCam: {}, // when double clicking a camera - it will toggle to single camera layout
  fullscreenView: false, // displays the camera grid in full screen or not
  editMode: false, // true when adding/deleting or moving cameras in a view
  showUnsavedViewModal: false, // prompts user to confirm saving or to notify unsaved view changes
  onCloseUnsavedViewModal: null, // holds the next onClick action if unsaved view changes prompt is cancelled
};

// eslint-disable-next-line
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case UPDATE_CAMSET:
      return {
        ...state,
        selectedSingleViewCam: {}
      }
    case TOGGLE_SINGLE_VIEW:
      return {
        ...state,
        selectedSingleViewCam: (Object.keys(state.selectedSingleViewCam).length) ? {} : action.payload,
      }
    case TOGGLE_FULLSCREEN_VIEW:
      return {
        ...state,
        fullscreenView: state.fullscreenView ? false : true,
      }
    case SET_LAYOUT:
    // if we are coming from a single view camera we need to keep the same camset
      return {
        ...state,
        selectedSingleViewCam: {}
      }
    case CHANGE_USER_VIEW:
      return {
        ...state,
        selectedSingleViewCam: {},
        editMode: false,
      }
    case LOGOUT_USER:
      return INITIAL_STATE
    case SET_VIEW:
      return {
        ...state,
        editMode: (state.editMode && action.payload !== 'live') ? false : state.editMode,
      }
    case UPDATE_CAMERAS_IN_VIEW:
      return {
        ...state,
        editMode: true,
      }
    case SHOW_UNSAVED_VIEW_MODAL:
      return {
        ...state,
        showUnsavedViewModal: action.show,
        onCloseUnsavedViewModal: action.onClose,
      }
    case SAVE_VIEW:
      return {
        ...state,
        editMode: false,
        showUnsavedViewModal: false,
        onCloseUnsavedViewModal: null,
      }
    default:
      return state;
  };
};